// extracted by mini-css-extract-plugin
module.exports = {"staff__title":"Staff_staff__title__DyI3Q","staff__description":"Staff_staff__description__Ev_tR","staff__children":"Staff_staff__children__omzJn"};